import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface AccountPrerequisiteDialogData {
  title?: string;
  message?: string;
  missingLabel: string;
  recommendedRouteLabel?: string;
}

export type AccountPrerequisiteDialogResult = "go" | "cancel" | "disable";

@Component({
  selector: "app-account-prerequisite-dialog",
  templateUrl: "./account-prerequisite-dialog.component.html",
  styleUrls: ["./account-prerequisite-dialog.component.scss"],
})
export class AccountPrerequisiteDialogComponent {
  data!: AccountPrerequisiteDialogData;

  constructor(
    private dialogRef: MatDialogRef<
      AccountPrerequisiteDialogComponent,
      AccountPrerequisiteDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) incomingData: AccountPrerequisiteDialogData,
  ) {
    const defaultData: AccountPrerequisiteDialogData = {
      title: "Complete account setup",
      message:
        "This area requires additional account configuration before it can be used.",
      missingLabel: incomingData.missingLabel,
      recommendedRouteLabel: "Go to setup",
    };
    this.data = { ...defaultData, ...incomingData };
  }

  onCancel(): void {
    this.dialogRef.close("cancel");
  }

  onGo(): void {
    this.dialogRef.close("go");
  }

  onDisable(): void {
    this.dialogRef.close("disable");
  }
}


